<template>
  <div class="container">
    <div id="title-of-save">
      <h1 id="title-text-child">
        Campaigns - QuickGuide
      </h1>
    </div>
    <div class="row margin-bottom-2">
      <div class="col">
        On the landing page, navigate to the menu item "Campaigns -> Quickguide" to enter the Campaigns overview.
        <br/>
        <br/>
        <img src="../../../assets/campaigns/home.png" class="col-xs-9" />
      </div>
    </div>
    <hr>
    <div class="row margin-bottom-2">
      <div class="col">
        <h2>Campaigns Overview</h2>
        The first screen of the campaigns manager shows the overview of all your campaigns.<br/>
        They are grouped into drafts, currently processed campaigns and finished campaigns.<br/>
        You can also start, clone or delete campaign drafts from here.
        <br/>
        <br/>
        <img src="../../../assets/campaigns/campaigns-home.png" class="col-xs-9" />
      </div>
    </div>
    <hr>
    <div class="row margin-bottom-2">
      <div class="col">
        <h2>Campaign Creation</h2>
        To create a new campaign, click the "Create" button, name your campaign and upload a CSV data file containing the recipient information and optional text elements.
        <br/>
        <br/>
        <img src="../../../assets/campaigns/campaigns-start.png" class="col-xs-9" />
      </div>
    </div>
    <div class="row margin-bottom-2">
      <div class="col">
        On the next screen, you select the data column with the recipient numbers and define the message text.<br/>
        To customize the text, you can use dynamic elements from the data file (drag and drop).
        <br/>
        <br/>
        <img src="../../../assets/campaigns/campaigns-editor.png" class="col-xs-9" />
      </div>
    </div>
    <div class="row margin-bottom-2">
      <div class="col">
        The next and last screen shows a summary with examples.<br/>
        Afterwards you have the choice to start sending the messages or go back to the campaigns overview and save the campaign for later (as draft).
        <br/>
        <br/>
        <img src="../../../assets/campaigns/campaigns-summary.png" class="col-xs-9" />
      </div>
    </div>
  </div>
</template>

<script>

</script>

<style scoped>


</style>
